import { z } from 'zod';
import { storeAlertCreate } from '../../crew/schema/storeAlert.js';
export const AlertTarget = {
    all: 'all',
    stores: 'stores',
};
const target = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal(AlertTarget.all) }),
    z.object({
        kind: z.literal(AlertTarget.stores),
        storeIds: z.array(z.number()).min(1, 'Select at least one store'),
    }),
]);
const create = storeAlertCreate.extend({
    subject: z.string().min(1, 'Subject is required'),
    message: z.string().min(1, 'Message is required'),
    target,
});
export const commandStoreAlert = {
    create,
    result: z.object({ storeCount: z.number() }),
};
//# sourceMappingURL=storeAlert.js.map